import React from 'react';
import ResponderMap from 'features/Responder/features/ResponderMap/index';

const TourMapEdit = (props) => (
  <ResponderMap
    enableTourTools={true}
    enableZones={false}
    enableTools={false}
    contextMenuMode="tour"
    autoSelectZones={false}
    {...props}
  />
);

export default TourMapEdit;
